import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = {
  "title": "Digital Craftsmanship",
  "slug": "digital-craftsmanship",
  "publishedAt": "2025-06-10T00:00:00.000Z",
  "readTime": "4 min read",
  "excerpt": "Thoughts on maintaining quality in a hurry-up culture.",
  "seoDescription": "Keeping quality in a hurry-up culture: what gets lost between shipping faster and scaling bigger and why craft is still the difference people feel.",
  "authorName": "Petri Lahdelma",
  "authorSlug": "petri-lahdelma",
  "mainImageUrl": "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/46eb4a68c7bd8e08f23cb83b8ebba0a73925ed34-1440x962.jpg?w=1600"
};
function _createMdxContent(props) {
  const _components = {
    blockquote: "blockquote",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Our very first lecture in design school was led by a passionate advocate for craftsmanship, Professor Tapio Vapaasalo. He began his lecture with showing a two distinctly different youtube videos. The first one featured a parrot that could mimic whatever the owner said, while the second one featured a craftsman who had spent years perfecting his skill. The difference was clear: the parrot could repeat words, but the craftsman created something meaningful."
    }), "\n", _jsx(_components.p, {
      children: "The tools are faster, the deadlines tighter and the expectations steeper. Somewhere between shipping faster and scaling bigger, something subtle gets lost. Not visibly. But you can feel it, in the way a product handles, in how a brand sounds, in the absence of something quietly intentional."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "That something is craft."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Speed Isn’t the Enemy: Thoughtlessness Is"
    }), "\n", _jsx(_components.p, {
      children: "I’ve worked long enough in digital to know that slowness doesn’t equal quality. But there’s a difference between moving fast with intent and just pushing to ship. We’ve built pipelines that automate, generate, even decide for us. But no automation substitutes the quiet friction of asking: Does this feel right? Does this deserve to exist this way?"
    }), "\n", _jsx(_components.p, {
      children: "That pause is not inefficiency. It’s where meaning starts."
    }), "\n", _jsx(_components.h2, {
      children: "Craft Is in the Edges"
    }), "\n", _jsx(_components.p, {
      children: "Good design isn’t only in the headline or the layout, it lives in the in-between. The microcopy that never sounds off. The loading animation that softens a delay. The way a transition suggests something human was here, thinking about how it would feel, how others would feel using it."
    }), "\n", _jsx(_components.p, {
      children: "Craftsmanship is about honoring the parts that don’t shout but shape the whole. It’s not about polish. It’s about presence."
    }), "\n", _jsx(_components.h2, {
      children: "Quality in the Age of Generators"
    }), "\n", _jsx(_components.p, {
      children: "AI is writing copy, generating layouts, filling in alt texts and icons and oftentimes doing it quite decently. But the danger isn’t in letting machines help. It’s in letting them decide what “good enough” looks like. When we stop noticing the difference, we stop caring."
    }), "\n", _jsx(_components.p, {
      children: "Craft today, more than ever, means keeping a human fingerprint on the product. Not because we should resist progress or the tools that deliver it, but because we’re still the ones accountable for the emotional resonance."
    }), "\n", _jsx(_components.h2, {
      children: "Leave Traces of Care"
    }), "\n", _jsx(_components.p, {
      children: "In every project, there’s a point where we could cut a corner and no one would notice. But someone always does, even if they can’t name it. Quality has a texture. It lingers. Not just in design, but in the culture it fosters: attention to detail becomes contagious. The team starts to raise their own bar."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Digital craftsmanship isn’t about perfection. It’s about giving a damn."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "In Praise of Slowness, Even When We’re Fast"
    }), "\n", _jsx(_components.p, {
      children: "We won’t go back to slower cycles. That’s not the point. But we can bake slowness into the process: quick iterations, slow reflection. Fast drafts, considered revisions. Space for questions no prompt can answer. In the end, craft is just a pattern of choices made deliberately, not reactively."
    }), "\n", _jsx(_components.p, {
      children: "In a hurry-up culture, choosing to care is radical.☻"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
